import { Link, useLocation } from "react-router-dom";

function SmartLink({ to, className, children }: { to: string; className?: string; children: React.ReactNode }) {
  const { pathname } = useLocation();
  return (
    <Link
      to={to}
      className={className}
      onClick={(e) => {
        if (pathname === to) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }}
    >
      {children}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="bg-ink text-cream pt-20 pb-10">
      <div className="mx-auto max-w-[1320px] px-6 md:px-10">
        {/* Top row */}
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10 border-b border-cream/10 pb-14">
          <div className="max-w-2xl">
            <h2 className="text-display text-3xl md:text-5xl leading-[1.1] text-balance mb-6">
              Vantory <span className="italic font-light">Labs</span> LTD
            </h2>
            <p className="text-cream/70 text-sm leading-relaxed text-balance">
              We are an IT company specializing in custom software development for businesses and private users,
              as well as comprehensive turnkey digital solutions. Our expertise spans custom software development,
              IT consulting, and digital marketing and advertising services. We help companies not only create
              technology-driven products, but also effectively bring them to market, attract users, and scale
              their business. We accompany projects at every stage — from idea and analytics to development,
              launch, and ongoing support.
            </p>
          </div>
          <div className="lg:max-w-sm w-full">
            <h4 className="text-xs uppercase tracking-widest2 text-cream/50 mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-cream/80">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-cream/50" />
                </span>
                <span>
                  109-111 Fulham Palace Road<br />
                  London, W6 8JA<br />
                  United Kingdom
                </span>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-cream/50" />
                </span>
                <a href="tel:+447451257361" className="hover:text-lime-accent transition-colors cursor-pointer">+447451257361</a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-cream/50" />
                </span>
                <a href="mailto:support@vantorylabs.com" className="hover:text-lime-accent transition-colors cursor-pointer">support@vantorylabs.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Middle */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 py-14">
          <div>
            <h4 className="text-xs uppercase tracking-widest2 text-cream/50 mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm">
              <li><SmartLink to="/about" className="cursor-pointer hover:text-lime-accent transition-colors">About Us</SmartLink></li>
              <li><SmartLink to="/services" className="cursor-pointer hover:text-lime-accent transition-colors">Our Services</SmartLink></li>
              <li><SmartLink to="/products" className="cursor-pointer hover:text-lime-accent transition-colors">Our Products</SmartLink></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-widest2 text-cream/50 mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><SmartLink to="/terms" className="cursor-pointer hover:text-lime-accent transition-colors">Terms of Use</SmartLink></li>
              <li><SmartLink to="/privacy" className="cursor-pointer hover:text-lime-accent transition-colors">Privacy Policy</SmartLink></li>
              <li><SmartLink to="/refund" className="cursor-pointer hover:text-lime-accent transition-colors">Refund Policy</SmartLink></li>
            </ul>
          </div>
          <div className="flex items-start md:justify-end">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-lime-accent text-ink px-6 py-3 text-xs font-semibold uppercase tracking-widest2 whitespace-nowrap cursor-pointer hover:bg-cream transition-colors"
            >
              Contact Us
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center justify-center gap-4 pt-8 border-t border-cream/10 text-xs text-cream/50">
          <p className="text-center w-full">© {new Date().getFullYear()} Vantory Labs LTD. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}